import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import WebhookForm from './WebhookForm';
import { useMutateWebhookHandler } from '../dataHandlers/mutateWebhookHandler';
import { usePermissions } from '../../../hooks/usePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';
import { CREATE_WEBHOOK_CONFIG } from '../../../constants/webhookPermissions';

const WebhookPageHeader = () => {
  const [openForm, setOpenForm] = useState(false);
  const { mutate } = useMutateWebhookHandler({});
  const { hasWebhookPermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const canCreate = hasWebhookPermission(CREATE_WEBHOOK_CONFIG);

  const handleCreate = (payload) => {
    if (!canCreate) {
      return;
    }
    mutate({ isEdit: false, payload });
    setOpenForm(false);
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" mb={4}>
        <Typography variant="h5" fontWeight={600}>
          Webhook Destinations
        </Typography>

        <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
          <Button variant="contained" startIcon={<AddIcon />} disabled={!canCreate} onClick={() => setOpenForm(true)}>
            Add Webhook
          </Button>
        </PermissionDeniedWrapper>
      </Box>

      <WebhookForm open={openForm} onClose={() => setOpenForm(false)} mode="create" onSubmit={handleCreate} />
    </>
  );
};

export default WebhookPageHeader;
